<template>
	<v-card>
		<v-card-title class="create-form-heading center"
			>Distribute Rewards</v-card-title
		>
		<div style="display:flex;" class="mb-4">
			<v-select
				:items="years"
				label="Select Year"
				hide-details
				v-model="selectedYear"
				@change="val => handleDropDownChange('yr', val)"
				class="px-2"
			></v-select
			><v-select
				:items="months"
				label="Select Month"
				hide-details
				v-model="selectedMonth"
				@change="val => handleDropDownChange('mo', val)"
				class="px-2"
			></v-select>
		</div>
		<div class="input-block">
			<v-flex class="pos-rel">
				<label for="files">Upload a CSV formatted file: </label>
				<input
					ref="inputUpload"
					type="file"
					@change="onFileChange"
					accept=".csv"
					required
					class="input"
				/>
				<v-icon class="cancel-icon" @click="clearInput">
					{{ "cancel" }}
				</v-icon>
			</v-flex>
			<v-flex>
				<v-btn
					depressed
					color="primary"
					class="upload-btn"
					@click="uploadFile()"
				>
					Upload
				</v-btn>
			</v-flex>
		</div>
		<div class="my-3 mx-3">
			<a
				target="_blank"
				:href="
					`${JEET_11_CDN_BASE_LINK}/sample-csv/distribute-rewards-sample.csv`
				"
				>Download sample file</a
			>
		</div>
		<v-snackbar bottom right v-model="alert.show"
			>{{ alert.text }}
		</v-snackbar>
		<v-container v-if="successRewards.length">
			<div class="font-weight-bold fz-16 mb-2">
				Successful Transactions:
			</div>
			<v-data-table
				:headers="headers"
				:items="successRewards"
				:items-per-page="5"
				class="elevation-1"
				v-if="successRewards.length"
				:themeInputColor="themeInputColor"
			>
				<template v-slot:items="props">
					<tr>
						<td class="text-xs-center px-2">
							{{ props.item.phoneNo }}
						</td>
						<td class="text-xs-center px-2">
							{{ props.item.amount }}
						</td>
						<td class="text-xs-center px-2">
							{{ props.item.reason }}
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-container>
		<v-container v-if="failRewards.length">
			<div class="font-weight-bold fz-16 mb-2">Failed Transactions:</div>
			<v-data-table
				:headers="headers"
				:items="failRewards"
				:items-per-page="5"
				class="elevation-1"
				:themeInputColor="themeInputColor"
			>
				<template v-slot:items="props">
					<tr>
						<td class="text-xs-center px-2">
							{{ props.item.phoneNo }}
						</td>
						<td class="text-xs-center px-2">
							{{ props.item.amount }}
						</td>
						<td class="text-xs-center px-2">
							{{ props.item.reason }}
						</td>
					</tr>
				</template>
			</v-data-table>
		</v-container>
	</v-card>
</template>
<script>
import { mapState } from "vuex";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { themeInputColor } from "@/utils";
import { SHOW_ALERT } from "@/store/action-types";
import { JEET_11_CDN_BASE_LINK } from "@/store/config";

export default {
	name: "FinanceBulkPayments",
	data: () => ({
		JEET_11_CDN_BASE_LINK,
		themeInputColor: themeInputColor,
		payload: [],
		successRewards: [],
		failRewards: [],
		headers: [
			{
				text: "Phone Number",
				value: "phoneNo",
				align: "center"
			},
			{ text: "Amount", value: "amount", align: "center" },
			{ text: "Reason", value: "reason", align: "center" }
		],
		years: [],
		months: [],
		selectedYear: 0,
		selectedMonth: 0
	}),
	mounted() {
		const date = new Date();
		const now = new Date().getUTCFullYear();
		const years = Array(now - (now - 20))
			.fill("")
			.map((__, idx) => now - idx);
		this.years = years;
		this.months = Array(12)
			.fill("")
			.map((__, idx) =>
				new Date(date.getYear(), idx).toLocaleDateString("default", {
					month: "long"
				})
			);
		this.selectedYear = this.years[0];
		this.selectedMonth = this.months[0];
	},
	methods: {
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.createPayload(files[0]);
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.payload = [];
		},
		createPayload(file) {
			const reader = new FileReader();
			reader.onload = e => {
				const fileData = e.target.result;
				const fileRows = fileData.split("\n");
				//Remove Heading Row
				fileRows.shift();
				const payload = fileRows.reduce((payload, row) => {
					if (row) {
						const columns = row.split(",");
						const phoneNo = columns[0].split(".")[0];
						const retailerPhoneNo = columns[1].split(".")[0];
						const amount = columns[2];
						const reason = columns[3];
						if (phoneNo.length > 7 && amount)
							payload.push({
								phoneNo: +phoneNo,
								amount: +amount,
								reason,
								retailerPhoneNo: +retailerPhoneNo
							});
					}
					return payload;
				}, []);
				this.payload = payload;
			};
			reader.readAsText(file);
		},
		async uploadFile() {
			const date = new Date();
			if (!this.payload.length) {
				this.showAlert("Please select a file to upload");
				return;
			}
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					rewards: this.payload,
					month:
						new Date(
							Date.parse(
								this.selectedMonth +
									`${date.getDate()}, ${date.getFullYear()}`
							)
						).getMonth() + 1,
					year: this.selectedYear
				}
			};
			try {
				const endpoint = `${BASE_URL}/jeet11-finance/v1.0.0/distributeRewards`;
				const response = await ApiService.post(endpoint, payload);
				const {
					status,
					errMsg,
					failRewards,
					successRewards
				} = response.response;
				if (status.toLowerCase() === "success") {
					this.successRewards = successRewards;
					this.failRewards = failRewards;
					this.clearInput();
				} else {
					this.showAlert(errMsg);
				}
			} catch (e) {
				this.showAlert(e.message);
			}
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		handleDropDownChange(type, val) {
			if (type === "yr") this.selectedYear = val;
			else this.selectedMonth = val;
		}
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	}
};
</script>
<style scoped>
.input-block {
	display: inline-block;
	margin: 30px 16px 0;
}
.upload-btn {
	margin: 10px 0 0;
	border-radius: 4px;
}
.cancel-icon {
	position: absolute;
	left: 100%;
}
.input {
	width: 200px;
}
</style>
